export { LanguageSelectorPage as default } from './language-selector';
